<div class="mail-list" (click)="detailMail();">
<!--  <div fxLayout="row" fxLayoutAlign="start center" class="w-p-100">-->

<!--    <div class="info w-p-100" fxFlex FlexLayout="column">-->

<!--      <div fxLayout="row" fxLayoutAlign="space-between start" class="mail-row-container">-->
<!--        <div fxLayout="row" class="mail-information" class="full-grow-no-shrink-no-basis">-->
<!--          <span class="text-truncate" *ngIf="item.cells?.LastModifiedBy" matTooltip="{{item.cells?.LastModifiedBy?.displayText}}">{{item.cells?.LastModifiedBy?.displayText}}</span>-->
<!--          <div class="message" *ngIf="item.cells.Title">-->
<!--            {{item.cells?.Title?.displayText | htmlToPlaintext | slice:0:180}}{{item.cells?.Title?.displayText.length > 180 ? '...' : ''}}-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="mail-time">{{item.cells?.LastModifiedDate?.displayText}} </div>-->
<!--      </div>-->
<!--      <div class="row-1" fxLayout="row" fxLayoutAlign="start center">-->
<!--        <div class="name" fxLayout="row" fxLayoutAlign="start center" fxFlex>-->
<!--          <mat-icon *ngIf="item.cells?.hasAttachments">attachment</mat-icon>-->
<!--        </div>-->
<!--        <div fxLayout="row" fxLayoutAlign="start center">-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--  <app-platform-mail-card-viewer [item]="item"></app-platform-mail-card-viewer>-->
</div>
